export default __webpack_public_path__ + "static/media/decimal.f975dfe8.svg";